import { record } from 'aws-amplify/analytics/kinesis';

export const sendToKinesis = async (eventType, action, payload) => {
  return record({
    data: {
      action,
      eventtype: eventType,
      ...payload,
      timestamp: new Date().toISOString(),
    },
    streamName: process.env.REACT_APP_STREAM_NAME,
    partitionKey: payload.userid || 'Anonymous',
  });
};
